export const SET_TEXT_AG_INTERNAL = "set/text/ag/internal"
export const SET_VOICE_AG_INTERNAL = "set/voice/ag/internal"
export const SET_AUDIO_LINK_AG_INTERNAL = "set/al/ag/internal"
export const SET_LANGUAGE_AG_INTERNAL = "set/text/lang/ag/internal"
export const SET_CLONE_AUDIO_AG_INTERNAL = "set/clone/audio/ag/internal"
export const SET_DOWNLOAD_AUDIO_AG_INTERNAL = "set/download/audio/ag/internal"